// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__zRLAH","header":"PatientQuestionnaire_header__ReAsK","info":"PatientQuestionnaire_info__2qcjI"};